/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export let AbSize = /*#__PURE__*/function (AbSize) {
  AbSize["EXTRA_SMALL"] = "ab-size-extra-small";
  AbSize["SMALL"] = "ab-size-small";
  AbSize["MEDIUM"] = "ab-size-medium";
  AbSize["LARGE"] = "ab-size-large";
  AbSize["EXTRA_LARGE"] = "ab-size-extra-large";
  AbSize["CUSTOM"] = "ab-size-custom";
  return AbSize;
}({});
//# sourceMappingURL=AbSize.js.map
